import { FC, memo } from 'react';

import UserItem from './components/UserItem/UserItem';
import { ListBody } from './UserList.styles';
import { UserListProps } from './UserList.types';

const UserList: FC<UserListProps> = memo((props) => {
    const { users, checkedUserIds, setCheckedUserIds } = props;

    return (
        <ListBody>
            {users.map((user, index) => (
                <UserItem
                    key={user.id}
                    user={user}
                    setCheckedUserIds={setCheckedUserIds}
                    checkedUserIds={checkedUserIds}
                    isLast={index === users.length - 1}
                />
            ))}
        </ListBody>
    );
});

export default UserList;
